<script setup lang="ts">
import { Bell, SidebarCollapse } from "@iconoir/vue";

defineProps<{
  collapsed?: boolean;
}>();

const emit = defineEmits<{
  (e: "toggle-sidebar"): void;
}>();

const { t } = useI18n();
const { title } = usePageTitle();
</script>

<template>
  <header class="topbar hidden md:flex">
    <div class="flex items-center gap-2xsmall flex-1 min-w-0">
      <ButtonIcon
        class="topbar__toggle"
        :class="{ 'is-collapsed': collapsed }"
        variant="flat-neutral"
        size="medium"
        shape="circle"
        :icon="SidebarCollapse"
        @click="emit('toggle-sidebar')"
      />
      <h1 class="topbar__title h3-primary">{{ title }}</h1>
    </div>

    <div class="flex items-center gap-small shrink-0">
      <Popover size="sm">
        <template #trigger>
          <ButtonIcon class="topbar__icon-btn" variant="tertiary" size="small" shape="circle">
            <Bell class="icon" />
          </ButtonIcon>
        </template>
        <div class="padding-medium">
          <span class="text-body-secondary">{{ t('ui.comingSoon') }}</span>
        </div>
      </Popover>

      <UserMenu />
    </div>
  </header>
</template>

<style scoped lang="scss">
.topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  height: token("dm-64");
  padding: 0 token("layout-margin");
  background: token("color-bg-surface");
  gap: token("gap-medium");
  border-bottom: 1px solid token("color-border-neutral-alpha-light-default");

  &__toggle {
    transition: transform token("motion-duration-slow") token("motion-ease-standard");

    &.is-collapsed {
      transform: rotate(180deg);
    }
  }

  &__title {
    color: token("color-content-neutral-strong");
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__icon-btn {
    width: token("comp-size-button-small");
    height: token("comp-size-button-small");
  }
}
</style>
